import * as Sentry from "@sentry/react";

export const shouldCaptureApiError = (error) => {
  const status = error?.response?.status;
  const isServerError = typeof status === "number" && status >= 500;
  const isNetworkError = !error?.response && !!error?.request;

  return isServerError || isNetworkError;
};

export const captureApiError = (
  error,
  { apiCall = "normalCall", fallbackTimeout } = {}
) => {
  if (!shouldCaptureApiError(error)) return;

  const status = error?.response?.status;

  Sentry.withScope((scope) => {
    scope.setTag("api_call_type", apiCall);
    scope.setTag("http_status", status || "network_error");
    scope.setLevel("error");
    scope.setContext("request", {
      method: error?.config?.method || "unknown",
      url: `${error?.config?.baseURL || ""}${error?.config?.url || ""}`,
      timeout: error?.config?.timeout || fallbackTimeout,
    });
    Sentry.captureException(error);
  });
};
